/**
 * @module actions/backdrop
 */
import {
  OPEN_MENU,
  OPEN_POPUP,
  OPEN_POPUP_BG,
  SET_INFO_MODAL,
  BODY_SCROLL
} from '../constants'

export function triggerMenuAction (state) {
  return {
    type: OPEN_MENU,
    state
  }
}

export function triggerPopupAction (state) {
  return {
    type: OPEN_POPUP,
    state
  }
}

export function triggerPopupActionBG (state) {
  return {
    type: OPEN_POPUP_BG,
    state
  }
}

export function triggerBodyScroll (bodyScroll) {
  return dispatch => {
    dispatch({
      type: BODY_SCROLL,
      bodyScroll: bodyScroll
    })
  }
}

export function triggerMenu (state) {
  return dispatch => {
    dispatch(triggerMenuAction(state))
  }
}

export function setInfoModal (content) {
  return dispatch => {
    dispatch({
      type: SET_INFO_MODAL,
      content
    })
  }
}

export function triggerPopup (state, type) {
  return dispatch => {
    if (type === 'bg') {
      dispatch(triggerPopupActionBG(state))
    } else {
      dispatch(triggerPopupAction(state))
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/backdrop.js